module.exports = __webpack_public_path__ + "assets/b-icon-32.png";